import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=dc5f01fe"
import script from "./scan.vue?vue&type=script&lang=js"
export * from "./scan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports